import * as Styled from './Button.styled';
import type { ButtonProps } from './Button.types';
import React from 'react';

const Button = React.forwardRef<HTMLButtonElement | null, ButtonProps>(
  (props, ref) => {
    const {
      inline = false,
      children,
      intent = 'primary',
      leading,
      trailing,
      type = 'button',
      height,
      ...rest
    } = props;
    return (
      <Styled.Button
        height={height}
        intent={intent}
        type={type}
        inline={inline}
        {...rest}
        ref={ref}
      >
        {!!leading && <Styled.Leading>{leading}</Styled.Leading>}
        {children}
        {!!trailing && <Styled.Trailing>{trailing}</Styled.Trailing>}
      </Styled.Button>
    );
  },
);

export default Button;
